import React, { useRef, useEffect, useState, useContext, useCallback } from 'react';
import { useHistory } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { BrCalendar } from './BrCalendar';
import '../layout/sass/_pickListSugestoes.scss'
import '../layout/sass/_responsiveTable.scss'
import api from '../api/api';
import { AuthContext } from '../contexts/AuthContext';
import { FilterContext } from '../contexts/FilterContext';
import { Dropdown } from 'primereact/dropdown';
import { DialogPrintBoletim } from './DialogPrintBoletim';
import { PermissaoLoader } from './PermissaoLoader';
import { permissions_check } from '../utils/rotas_permissao';
import moment from 'moment';

export const TabelaBoletim = () => {
    const toast = useRef(null);
    const [boletins, setBoletins] = useState([]);
    const [produtor, setProdutor] = useState([]);
    const [propriedade, setPropriedade] = useState([]);
    const [tecnico, setTecnico] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const confirmationToast = useRef(null)
    const [dt, setDt] = useState(null);
    const history = useHistory();

    const [sortable, setSortable] = useState('DESC');
    const [sortableCampo, setSortableCampo] = useState('id');
    const [first, setFirst] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const { user, permissoes } = useContext(AuthContext);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedPropriedade, setSelectedPropriedade] = useState(null);
    const [selectedTecnico, setSelectedTecnico] = useState(null);
    const filterStatus = renderFilterStatus();
    const filterPropriedade = renderFilterPropriedade();
    const filterTecnico = renderFilterTecnico();
    const { filter, setFilter } = useContext(FilterContext);
    const [selectedDataEmissao, setSelectedDataEmissao] = useState(null);
    const [selectedDataVigencia, setSelectedDataVigencia] = useState(null);
    const [showActionsColumn, setShowActionsColumn] = useState(true);

    const [showPrintBoletim, setShowPrintBoletim] = useState(false);
    const [boletimPrint, setBoletimPrint] = useState([]);

    useEffect(() => {

        (async function boletim() {
            await mapearProdutor();
            await mapearPropriedade();
            await mapearTecnico();
        })();

        return () => {
            setProdutor([])
            setPropriedade([])
            setTecnico([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const header = (
        <div className="p-grid p-col-12 p-m-0 p-p-0">
            <div>
                <h2 className="p-my-0">Boletins</h2>
            </div>
            <div className="p-my-0 p-grid p-dir-rev p-col">
                <div className="p-m-2">
                    <PermissaoLoader rota="boletim" acao="criar" onClick={() => history.push('/boletimcreate')} />
                </div>
                <div className="p-m-2">
                    <Button
                        label="Limpar Filtros"
                        className="p-mb-2 p-button-primary"
                        iconPos="left"
                        type="button"
                        onClick={() => handleLimparClick()}
                    />
                </div>
            </div>
        </div>

    );

    const handleLimparClick = () => {
        setFilter({
            first: 0,
            rows: 20,
            sortField: null,
            sortOrder: null,
            filters: {
                'id': { value: null, matchMode: 'contains' },
                'produtor': { value: null, matchMode: 'equals' },
                'propriedade': { value: null, matchMode: 'equals' },
                'tecnico': { value: null, matchMode: 'equals' },
                'produtoNome': { value: null, matchMode: 'equals' },
                'dataEmissao': { value: null, matchMode: 'equals' },
                'dataVigencia': { value: null, matchMode: 'equals' },
            },

        });
        setSelectedStatus(null);
        setSelectedPropriedade(null);
        setSelectedTecnico(null);
        setSelectedDataEmissao(null);
        setSelectedDataVigencia(null);
    }

    const onSort = (event) => {

        setSortableCampo(event.sortField);
        if (sortable === 'ASC') {
            setSortable('DESC')
        } else if (sortable === 'DESC') {
            setSortable('ASC')
        }

    }

    const onFilter = (event) => {
        event['first'] = 0;
        setFilter(event);
    }

    const getBoletins = useCallback(async (event) => {
        setIsLoading(true)
        setBoletins([])

        if (event !== undefined) {
            setTimeout(() => {
                const startIndex = event.first;

                setFirst(startIndex);
            }, 250);
        }

        try {

            var pesquisa = {
                "id": null,
                "produtor": null,
                "propriedade": null,
                "tecnico": null,
                "produtoNome": null,
                "dataEmissao": null,
                "dataVigencia": null,
            }

            if (filter.filters !== undefined) {

                pesquisa = {
                    "id": filter.filters['id'] !== undefined ? filter.filters['id'].value : null,
                    "produtor": filter.filters['produtor'] !== undefined ? filter.filters['produtor'].value : null,
                    "propriedade": filter.filters['propriedade'] !== undefined ? filter.filters['propriedade'].value : null,
                    "tecnico": filter.filters['tecnico'] !== undefined ? filter.filters['tecnico'].value : null,
                    "produtoNome": filter.filters['produtoNome'] !== undefined ? filter.filters['produtoNome'].value : null,
                    "dataEmissao": filter.filters['dataEmissao'] !== undefined ? filter.filters['dataEmissao'].value : null,
                    "dataVigencia": filter.filters['dataVigencia'] !== undefined ? filter.filters['dataVigencia'].value : null,
                }


            }
            if (event === undefined) {

                const respElements = await api.post(`boletim/searchBoletim/${sortable}/${sortableCampo}?page=${0}`, pesquisa);
                respElements.data.content.forEach(boletim => {
                    setBoletins(boletins => [...boletins, boletim])
                })
                setTotalRecords(respElements.data.totalElements);
            } else {

                const respElements = await api.post(`boletim/searchBoletim/${sortable}/${sortableCampo}?page=${event.page}`, pesquisa);
                respElements.data.content.forEach(boletim => {
                    setBoletins(boletins => [...boletins, boletim])
                })
                setTotalRecords(respElements.data.totalElements);
            }

        }
        catch (error) {

            console.log("chegou do erro ------ " + error)

            if (filter !== undefined) {
                if (event === undefined) {
                    const response = await api.get(`boletim?sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(boletim => {
                        setBoletins(boletins => [...boletins, boletim])
                    })
                } else {
                    const response = await api.get(`boletim?page=${event.page}&sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(boletim => {
                        setBoletins(boletins => [...boletins, boletim])
                    })

                }

                const respElements = await api.get(`boletim?sort=${sortableCampo},${sortable}`);
                setTotalRecords(respElements.data.totalElements);
            } else {
                toast.current.show({ severity: 'error', summary: 'Erro ao obter boletim', detail: error.toString() });
            }

        }

        setIsLoading(false)
    }, [filter, sortable, sortableCampo]);

    useEffect(() => {
        const fetchBoletins = async () => {
            try {
                await getBoletins();
            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Erro ', detail: error.toString() });
            }
        }
        fetchBoletins();

    }, [getBoletins])

    const actionBodyTemplate = (rowData) => {
        const hasEditPermission = permissions_check("boletim", "editar", permissoes);
        const hasDeletePermission = permissions_check("boletim", "deletar", permissoes);

        if (!hasEditPermission && !hasDeletePermission) {
            // setShowActionsColumn(false);

            return <div className="actions">
                <Button icon="pi pi-print" className="p-button-rounded p-mr-2 edit-btn" onClick={() => handlePrintClick(rowData)} />
            </div> // No actions to show
        }

        return (
            <div className="actions">
                <Button icon="pi pi-print" className="p-button-rounded p-mr-2 edit-btn" onClick={() => handlePrintClick(rowData)} />
                <Button icon="pi pi-pencil" className="p-button-rounded p-mr-2 edit-btn" onClick={() => handleEditClick(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-mr-2 p-button-danger" loading={isDeleting} onClick={() => handleDeleteClick(rowData)} />

            </div>
        );
    };


    const handlePrintClick = (data) => {
        // console.log(filter);
        // console.log(data)
        api.get(`/boletim/saldo/${data.id}`).then((response) => {

            setBoletimPrint([response.data]);
        })

        setTimeout(() => {
            setShowPrintBoletim(true);
        }, 1000)
    }

    const codigoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Código</span>
                    <span className="table-data">{rowData.id}</span>
                </p>
            </React.Fragment>
        );
    }

    const dataEmissaoBodyTemplate = (rowData) => {
        
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Data Emissão</span>
                    <span className="table-data"> {moment(rowData.dataEmissao).format('DD/MM/YYYY')}</span>
                </p>
            </React.Fragment>
        );
    }

    const produtorBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Nome do Produtor</span>
                    <span className="table-data">{rowData.produtor}</span>
                </p>
            </React.Fragment>
        );
    }

    const propriedadeBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Propriedade</span>
                    <span className="table-data">{rowData.propriedade}</span>
                </p>
            </React.Fragment>
        );
    }

    const tecnicoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Técnico do Emater</span>
                    <span className="table-data">{rowData.tecnico}</span>
                </p>
            </React.Fragment>
        );
    }

    const vigenciaBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Vigência</span>                    
                    <span className="table-data"> {moment(rowData.dataVigencia).format('DD/MM/YYYY')}</span>
                </p>
            </React.Fragment>
        );
    }

    const mapearProdutor = async () => {
        const response = await api.get(`pessoa/tipo/1`);
        setProdutor(response.data.map(produtor => {
            var prod = { label: '', value: '' };
            prod.label = produtor.nome
            prod.value = produtor.id

            return prod
        }))
        filter.filters !== undefined && (filter.filters.produtor !== undefined && filter.filters.produtor.value !== null) ? setSelectedStatus(filter.filters.produtor.value) : setSelectedStatus(null)
    }

    const mapearPropriedade = async () => {
        const response = await api.get(`propriedade/propriedadeAll`);
        setPropriedade(response.data.map(propriedade => {
            var prop = { label: '', value: '' };
            prop.label = propriedade.nome
            prop.value = propriedade.id

            return prop
        }))
        filter.filters !== undefined && (filter.filters.propriedade !== undefined && filter.filters.propriedade.value !== null) ? setSelectedPropriedade(filter.filters.propriedade.value) : setSelectedPropriedade(null)
    }

    const mapearTecnico = async () => {
        const response = await api.get(`pessoa/tipo/2`);
        setTecnico(response.data.map(tecnico => {
            var tecn = { label: '', value: '' };
            tecn.label = tecnico.nome
            tecn.value = tecnico.id

            return tecn
        }))
        filter.filters !== undefined && (filter.filters.tecnico !== undefined && filter.filters.tecnico.value !== null) ? setSelectedTecnico(filter.filters.tecnico.value) : setSelectedTecnico(null)
    }

    const onStatusSearchChange = (event) => {
        if (event.value !== null) {
            dt.filter(event.value, 'produtor', 'equals');
            setSelectedStatus(event.value);
        }
        else
            dt.filter(null, 'produtor', 'equals');
    }
    function renderFilterStatus() {
        return (
            <Dropdown
                value={selectedStatus}
                options={produtor}
                onChange={(e) => onStatusSearchChange(e)}
                placeholder="Selecione um produtor"
                className="p-column-filter"
                filter
                showClear={true} />
        );
    }

    const onPropriedadeSearchChange = (event) => {
        if (event.value !== null) {
            dt.filter(event.value, 'propriedade', 'equals');
            setSelectedPropriedade(event.value);
        }
        else
            dt.filter(null, 'propriedade', 'equals');
    }

    function renderFilterPropriedade() {
        return (
            <Dropdown
                value={selectedPropriedade}
                options={propriedade}
                onChange={(e) => onPropriedadeSearchChange(e)}
                placeholder="Selecione uma propriedade"
                className="p-column-filter"
                filter
                showClear={true} />
        );
    }

    const onTecnicoSearchChange = (event) => {
        if (event.value !== null) {
            dt.filter(event.value, 'tecnico', 'equals');
            setSelectedTecnico(event.value);
        }
        else
            dt.filter(null, 'tecnico', 'equals');
    }

    function renderFilterTecnico() {
        return (
            <Dropdown
                value={selectedTecnico}
                options={tecnico}
                onChange={(e) => onTecnicoSearchChange(e)}
                placeholder="Selecione uma técnico"
                className="p-column-filter"
                filter
                showClear={true} />
        );
    }

    const handleEditClick = (data) => {

        history.push(`/boletim/edit/${data.id}`);

    }

    const handleDeleteClick = (data) => {

        data['userEmail'] = user.email

        confirmDialog({
            message: `Você tem certeza que quer remover ${data.produtor.nome}?`,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: async () => {
                setIsDeleting(true);

                try {

                    await api.delete(`boletim/${data.id}`);

                    toast.current.show({ life: 5000, severity: 'success', summary: 'Remoção concluída!', detail: `Boletim ${data.produtor.nome} removido(a) com sucesso` });
                    getBoletins()
                }
                catch (error) {
                    toast.current.show({ life: 5000, severity: 'error', summary: 'Erro ao remover o boletim', detail: error.response.data });
                }

                setIsDeleting(false);
            },
            reject: () => { return }
        });
    }

    const onDataEmissaoSearchChange = (event) => {
        if (event.value !== null) {
            let data = new Date(event.value).toISOString().split('T')[0];;
                        
            dt.filter(data, 'dataEmissao', 'equals');
            setSelectedDataEmissao(event.value);
            
        }
        else
            dt.filter(null, 'dataEmissao', 'equals');
    }

    const onDataEmissaoInputChange = (event) => {
        if (event.target.value !== null) {
            let data = new Date(event.target.value.split('/').reverse().join('/')).toISOString();
            dt.filter(data, 'dataEmissao', 'equals');
            setSelectedDataEmissao(new Date(event.target.value.split('/').reverse().join('/')));
        }
        else
            dt.filter(null, 'dataEmissao', 'equals');
    }

    const onDataVigenciaSearchChange = (event) => {
        if (event.value !== null) {
            let data = new Date(event.value).toISOString();
            dt.filter(data, 'dataVigencia', 'equals');
            setSelectedDataVigencia(event.value);
        }
        else
            dt.filter(null, 'dataVigencia', 'equals');
    }

    const onDataVigenciaInputChange = (event) => {
        if (event.target.value !== null) {
            let data = new Date(event.target.value.split('/').reverse().join('/')).toISOString();
            dt.filter(data, 'dataVigencia', 'equals');
            setSelectedDataVigencia(new Date(event.target.value.split('/').reverse().join('/')));
        }
        else
            dt.filter(null, 'dataVigencia', 'equals');
    }

    return (
        <>
            <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">

                <Toast ref={toast} position="bottom-right" />

                <Toast ref={confirmationToast} position="bottom-center" />

                <div className="card p-col-12 datatable-responsive-demo">

                    <div className="p-fluid">

                        <DataTable
                            totalRecords={totalRecords}
                            lazy="true"
                            first={first}
                            onPage={getBoletins}
                            ref={(element) => setDt(element)}
                            header={header}
                            value={boletins}
                            filterDisplay="row"
                            className="p-datatable-responsive-demo"
                            emptyMessage="Nenhuma boletim encontrada"
                            loading={isLoading}
                            dataKey="id"
                            paginator
                            rows={20}
                            currentPageReportTemplate={`Mostrando de {first} a {last} de ${totalRecords} boletins`}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                            // rowsPerPageOptions={[10, 20, 30]}
                            // sortField="nome"
                            // sortOrder={1}
                            // removableSort
                            onSort={onSort}
                            onFilter={onFilter}
                            filters={filter.filters}
                        >

                            <Column
                                field="id"
                                header="Código"
                                sortable={sortable}
                                body={codigoBodyTemplate}
                                filter
                                filterType='number'
                                filterMatchMode="contains"
                                filterPlaceholder={filter.filters !== undefined && (filter.filters.id !== undefined && filter.filters.id.value !== null) ? filter.filters.id.value : "Pesquisar pelo Código"}

                            />
                            <Column
                                field="dataEmissao"
                                header="Data Emissão"
                                sortable={sortable}
                                body={dataEmissaoBodyTemplate}
                                filter
                                filterElement={
                                    <BrCalendar
                                        key={selectedDataEmissao}
                                        id="dataEmissao"
                                        name="dataEmissao"
                                        value={selectedDataEmissao}
                                        onSelect={(e) => onDataEmissaoSearchChange(e)}
                                        onInput={(e) => onDataEmissaoInputChange(e)}
                                        yearRange={`2000:${new Date().getFullYear() + 2}`}
                                        placeholder="Selecione uma data"
                                        onClearButtonClick={() => handleLimparClick()}
                                        disabledDays="none"
                                    />
                                }

                            />

                            <Column
                                field="produtor"
                                header="Nome do Produtor"
                                sortable={sortable}
                                body={produtorBodyTemplate}
                                filter
                                filterMatchMode="equals"
                                filterElement={filterStatus}

                            />

                            <Column style={{ width: '20%' }}
                                field="propriedade"
                                header="Nome da Propriedade"
                                sortable={sortable}
                                body={propriedadeBodyTemplate}
                                filter
                                filterMatchMode="equals"
                                filterElement={filterPropriedade}

                            />


                            <Column
                                field="tecnico"
                                header="Nome do Técnico"
                                sortable={sortable}
                                body={tecnicoBodyTemplate}
                                filter
                                filterMatchMode="equals"
                                filterElement={filterTecnico}

                            />

                            <Column
                                field="dataVigencia"
                                header="Vigência"
                                sortable={sortable}
                                body={vigenciaBodyTemplate}
                                filter
                                filterElement={
                                    <BrCalendar
                                        key={selectedDataVigencia}
                                        id="dataVigencia"
                                        name="dataVigencia"
                                        value={selectedDataVigencia}
                                        onSelect={(e) => onDataVigenciaSearchChange(e)}
                                        onInput={(e) => onDataVigenciaInputChange(e)}
                                        yearRange={`2000:${new Date().getFullYear() + 2}`}
                                        placeholder="Selecione uma data"
                                        onClearButtonClick={() => handleLimparClick()}
                                        disabledDays="none"
                                    />
                                }

                            />

                            {showActionsColumn && (
                                <Column style={{ width: '17%' }}
                                    header="Ações"
                                    field="produtoNome"
                                    body={actionBodyTemplate}
                                />
                            )}

                        </DataTable>

                        <DialogPrintBoletim
                            visible={showPrintBoletim}
                            setVisible={setShowPrintBoletim}
                            setBoletins={setBoletimPrint}
                            boletins={boletimPrint}
                        />

                    </div>
                </div>
            </div>

        </>
    );
}
